'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type SignUpCtaProps = {
    variant?: 'inline' | 'button' | 'toast' | 'error-action'
    className?: string
    children?: React.ReactNode
    onClick?: () => void
}

export function SignUpCta({ variant = 'inline', className, children, onClick }: SignUpCtaProps) {
    if (variant === 'button') {
        return (
            <Button asChild size="sm" className={className}>
                <Link href="/auth/sign-up">Sign up</Link>
            </Button>
        )
    }

    if (variant === 'toast') {
        return (
            <Button 
                asChild 
                size="sm" 
                className={cn(
                    "h-6",
                    className,
                )}
            >
                <Link href="/auth/sign-up">Sign up</Link>
            </Button>
        )
    }

    if (variant === 'error-action') {
        return (
            <Button 
                size="sm" 
                className={className} 
                onClick={onClick}>
                {children}
            </Button>
        )
    }

    return (
        <Link
            href="/auth/sign-up"
            className={cn('text-primary', className)}
        >
            <span className="underline underline-offset-4">Sign up here</span> <span className="text-muted-foreground">and get 500 free credits</span>
        </Link>
    )
}


